module.exports = __webpack_public_path__ + "img/scan.8b5931d9.svg";